export const SHARING = 3;

export const BODY = 2;

export const INTRO = 1;

export const INTRO__FILTERS = 2;
export const INTRO__CLOUD_ITEMS = 1;

export const INTRO__CLOUD_ITEMS__ZOOMED = 4;
export const INTRO__CLOUD_ITEMS__TWINKLING = 4;
export const INTRO__CLOUD_ITEMS__TITLE = 3;
export const INTRO__CLOUD_ITEMS__FRONT = 2;
export const INTRO__CLOUD_ITEMS__MIDDLE = 1;
export const INTRO__CLOUD_ITEMS__BACK = 0;
export const INTRO__CLOUD_ITEMS__INACTIVE = 0;

export const FOOTER = -1;



// WEBPACK FOOTER //
// ./src/theme/layers.js